import { Component, ElementRef, inject, input, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core'
import { NavItem } from '../../../../core/interfaces/nav/nav-item.interface'

@Component({
    selector: 'sq-sidebar-nav-title',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '',
})
export class SidebarNavTitleComponent implements OnInit {
    readonly #elementRef = inject(ElementRef)
    readonly #renderer = inject(Renderer2)
    item = input.required<NavItem>()

    ngOnInit(): void {
        const item = this.item()

        if (!item) {
            return
        }

        const nativeElement: HTMLElement = this.#elementRef.nativeElement
        const name = this.#renderer.createText(item.name!)

        if (item.class) {
            const classes = item.class
            this.#renderer.addClass(nativeElement, classes)
        }

        if (item.wrapper) {
            const wrapper = this.#renderer.createElement(item.wrapper.element)
            this.addAttribs(item.wrapper.attributes, wrapper)
            this.#renderer.appendChild(wrapper, name)
            this.#renderer.appendChild(nativeElement, wrapper)
        } else {
            this.#renderer.appendChild(nativeElement, name)
        }
    }

    private addAttribs(attribs: { [x: string]: any }, element: any): void {
        if (attribs) {
            for (const attr in attribs) {
                if (attr === 'style' && typeof attribs[attr] === 'object') {
                    this.setStyle(attribs[attr], element)
                } else if (attr === 'class') {
                    this.addClass(attribs[attr], element)
                } else {
                    this.setAttrib(attr, attribs[attr], element)
                }
            }
        }
    }

    private setStyle(styles: { [x: string]: any }, el: any): void {
        for (const style in styles) {
            if (style) {
                this.#renderer.setStyle(el, style, styles[style])
            }
        }
    }

    private addClass(classes: string | string[], el: any): void {
        const classArray = Array.isArray(classes) ? classes : classes.split(' ')
        classArray
            .filter((element) => element.length > 0)
            .forEach((element) => {
                this.#renderer.addClass(el, element)
            })
    }

    private setAttrib(key: string, value: string, el: any): void {
        this.#renderer.setAttribute(el, key, value)
    }
}
